module.exports = __webpack_public_path__ + "media/images/icons/twotone/api-69c901ea8e5f8bf0a4242fd8046cc2b1.svg";